<template>
  <NavigationBarLink
    :collapsed-after-animation="collapsedAfterAnimation"
    :collapsed-navigationbar="collapsedNavigationbar"
    icon="extension"
    :label="$t('navigationBar.plugins')"
    :to="{ name: $routes.Plugins }"
  />

  <template
    v-for="item in pluginsItems"
    :key="item.label"
  >
    <NavigationBarLink
      :collapsed-after-animation="collapsedAfterAnimation"
      :collapsed-navigationbar="collapsedNavigationbar"
      :label="item.label"
      :to="item.to"
    />
  </template>
</template>

<script lang="ts" setup>
import type { HubDaemon } from '@robovision/hub'
import { storeToRefs } from 'pinia'
import type { PropType } from 'vue'
import { computed } from 'vue'
import { RouteNames } from '~router/routeNames'
import { useDaemonsStore } from '~stores/useDaemonsStore'
import NavigationBarLink from './NavigationBarLink.vue'


defineProps({
  collapsedAfterAnimation: {
    required: true,
    type: Boolean as PropType<boolean>,
  },
  collapsedNavigationbar: {
    required: true,
    type: Boolean as PropType<boolean>,
  },
})

const daemonsStore = useDaemonsStore()
const { daemons } = storeToRefs(daemonsStore)

const pluginsItems = computed(() => {
  return daemons.value.map((daemon: HubDaemon) => {
    return {
      label: daemon.definitionId,
      to: {
        name: RouteNames.PluginDetails,
        params: {
          algorithmId: daemon.algorithmId,
          algorithmVersion: daemon.algorithmVersion,
          daemonId: daemon.definitionId,
        },
      },
    }
  })
})
</script>

<style lang="sass" scoped>
@import '../css/quasar.variables'
</style>
